import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/spotwrite.png'


const _withScopeId = n => (_pushScopeId("data-v-50bd0676"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sw-brand--site-name" }
const _hoisted_2 = ["alt"]
const _hoisted_3 = { class: "sw-brand--site-sub-name" }

import {
  computed, withDefaults,
} from 'vue';

type BrandColorType = 'primary';

interface Props {
  siteName?: string;
  siteSubName?: string;
  color?: BrandColorType;
  horizontal?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SwBrand',
  props: {
    siteName: { default: 'SPOTWRITE' },
    siteSubName: { default: 'スポットライト' },
    color: { default: 'primary' },
    horizontal: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { siteName: string, siteSubName: string, color: BrandColorType, horizontal: boolean }



/**
 * class 属性
 */
const classes = computed(() => ({
  'sw-brand': true,
  'sw-brand--horizontal': props.horizontal,
  [`sw-brand--${props.color || 'primary'}`]: true,
}));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(classes))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: __props.siteName
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.siteSubName), 1)
  ], 2))
}
}

})